module.exports = __webpack_public_path__ + "static/cabina-de-conductor---mampara-divisoria-38e0ea73829eceb8d8f29ab776e6d875.jpg";